<template>
  <div class="overframe">
    <!-- 侧边菜单 -->
    <SideBar
      ref="sidebar"
      :operatorStatusDict="operatorStatusDict"
      @operation="dealSidebarOperation"
    ></SideBar>
    <!-- 信息登记 -->
    <InfoRegistration
      ref="infoRegistration"
      v-if="isNeedInfoRegistrationShow"
      :callType="callType"
      @close="closeInfoRegistration"
    ></InfoRegistration>
    <!-- 呼入弹框 -->
    <div v-if="isNeedNewCallInDialogShow && pendingCallList.length > 0" class="need-event">
      <RBDialog title="你有新的来电" @close="closeNewCallInDialog">
        <div class="call-in-single-dialog" v-if="pendingCallList.length == 1">
          <div>{{ pendingCallList[0] }}</div>
        </div>
        <div class="call-in-multi-dialog" v-else>
          <!-- 只截取前10个出来展示，否则电话爆发时界面无法容纳 -->
          <div v-for="(item, index) in pendingCallList.slice(0, 10)" :key="item.num">
            <span>{{ item }}</span>
            <span>{{ `前面${index}位` }}</span>
          </div>
        </div>
      </RBDialog>
    </div>
    <!-- 被强拆弹框 -->
    <div v-if="isNeedAbortDialogShow" class="need-event">
      <RBDialog title="强拆提醒" @close="isNeedAbortDialogShow = false">
        <div class="common-dialog">通话被话务管理员强拆</div>
      </RBDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SideBar from './sidebar';
import RBDialog from './RBDialog';
import InfoRegistration from './info-registration';
import { getDictApi } from '@/api/call-system';
import { operatorStatusMap } from '../common';

export default {
  name: 'CallSidebar',
  components: {
    SideBar,
    RBDialog,
    InfoRegistration,
  },
  data() {
    return {
      operatorStatusMap, // 坐席状态映射
      socketPrePath: '', // websocket的地址前缀
      socketObj: null, // websocket对象
      socketInterval: -1, // websocket心跳的定时器
      lockReInitWS: false, // 是否锁定重连websocket
      reInitWSTimer: -1, // 重连websocket的定时器
      operatorStatusDict: [], // 坐席状态字典
      isNeedInfoRegistrationShow: false, // 是否需要展示信息登记页面
      callType: '', // 呼叫类型 callIn-呼入 callOut-呼出
      isNeedNewCallInDialogShow: false, // 是否需要展示来电弹框
      pendingCallList: [], // 待接听的来电列表
      isNeedAbortDialogShow: false, // 是否需要展示被强拆弹框
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    getDictApi({
      code: 'callcenter_service_work_status',
    }).then(({ data }) => {
      this.operatorStatusDict = data;
    });
  },
  methods: {
    /* 处理侧边栏的操作 */
    dealSidebarOperation(operation) {
      if (operation == 'login' || operation == 'back') {
        this.initWebsocket();
      } else if (operation == 'logout') {
        this.closeWebsocket();
      } else if (operation == 'call') {
        this.checkInfoRegistration('callOut');
      }
    },
    /* 建立websocket连接 */
    initWebsocket() {
      try {
        if (!this.socketPrePath) {
          if (window.location.host.indexOf('localhost') != -1) {
            this.socketPrePath = 'ws://cjyl-test.pms1.cn/ws'; // 本地调试
          } else if (window.location.protocol.indexOf('https') == 0) {
            this.socketPrePath = 'wss://' + window.location.host + '/ws';
          } else {
            this.socketPrePath = 'ws://' + window.location.host + '/ws';
          }
        }
        let socketPath =
          this.socketPrePath + '/v4ward/callcenter/websocket?userId=' + this.userInfo.user_id;
        this.socketObj = new WebSocket(socketPath);
        this.socketObj.onopen = this.socketOpen;
        this.socketObj.onmessage = this.socketMsg;
        this.socketObj.onerror = () => {
          clearInterval(this.socketInterval);
          this.reInitWebsocket(); // 重连
        };
        this.socketObj.onclose = (e) => {
          clearInterval(this.socketInterval);
        };
      } catch (error) {
        this.reInitWebsocket();
      }
    },
    /* 重连websocket */
    reInitWebsocket() {
      if (this.lockReInitWS) return;
      this.lockReInitWS = true;
      clearTimeout(this.reInitWSTimer);
      this.reInitWSTimer = setTimeout(() => {
        this.lockReInitWS = false;
        this.initWebsocket();
      }, 2000);
    },
    /* websocket连接成功 */
    socketOpen() {
      // 发送心跳
      clearInterval(this.socketInterval);
      this.socketInterval = setInterval(() => {
        let heartBeat = {
          data: 'heartbeat',
          eventType: 'HEARTBEAT',
          time: new Date().getTime(),
        };
        this.socketObj.send(JSON.stringify(heartBeat));
      }, 30000);
    },
    /* 接收到websocket消息 */
    socketMsg(msg) {
      let msgData = JSON.parse(msg.data);
      // console.log('socketMsg msgData:', msgData);
      let { eventType, data } = msgData;
      // 后端目前只实现了单独来电消息推送，不支持排队的情况，所以这里的待接听列表需要重置
      switch (eventType) {
        case 'RING': // 新来电
          this.pendingCallList = [data];
          this.showNewCallInDialog();
          break;
        case 'ANSWERED': // 已接听
          let info = JSON.parse(data);
          this.checkInfoRegistration(info.callType == 2 ? 'callOut' : 'callIn');
          this.pendingCallList = [];
          this.closeNewCallInDialog();
          this.$store.commit('callSystem/SET_CALL_INFO', info);
          this.$store.commit('callSystem/SET_OPERATOR_STATUS', this.operatorStatusMap.incall);
          break;
        case 'BYE': // 挂机
        case 'CLEAR': // 强拆
          this.$store.commit('callSystem/SET_OPERATOR_STATUS', this.operatorStatusMap.aftercall);
          if (eventType === 'CLEAR') {
            this.isNeedAbortDialogShow = true;
          }
          break;
        case 'BARGEIN': // 强插
          this.$store.commit('callSystem/SET_INSERT_INFO', JSON.parse(data));
          break;
        case 'MONITOR': // 监听
          this.$store.commit('callSystem/SET_LISTEN_INFO', JSON.parse(data));
          break;
        default:
      }
    },
    /* 关闭websocket连接 */
    closeWebsocket() {
      clearInterval(this.socketInterval);
      this.socketObj.close();
    },
    /* 检测信息登记界面 */
    checkInfoRegistration(callType) {
      // 先关闭旧界面，再重新展示新界面，保证组件数据可以正常刷新
      if (this.isNeedInfoRegistrationShow) {
        this.closeInfoRegistration();
      }
      this.showInfoRegistration(callType);
    },
    /* 显示信息登记界面 */
    showInfoRegistration(callType) {
      this.callType = callType;
      this.isNeedInfoRegistrationShow = true;
    },
    /* 关闭信息登记界面 */
    closeInfoRegistration() {
      this.isNeedInfoRegistrationShow = false;
      this.callType = '';
    },
    /* 显示来电弹框 */
    showNewCallInDialog() {
      this.isNeedNewCallInDialogShow = true;
    },
    /* 关闭来电弹框 */
    closeNewCallInDialog() {
      this.isNeedNewCallInDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.overframe {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* 设置 pointer-events: none; 后当前组件就无法接收到点击事件了，不过可以对需要接收点击事件的元素加上 pointer-events: auto; 就可以接收到点击事件了 */
  pointer-events: none;
  /* 此处的层级不要一味追求大，否则有些提示（比如 el-tooltips、$message 提示等）无法显示出来 */
  z-index: 2000;
  /* 清除avue-top的样式继承 */
  line-height: initial;
  /* 默认字体大小 */
  font-size: 16px;

  /* 需要拦截按键的dom元素需要加上此css类 */
  .need-event {
    pointer-events: auto;
  }

  /* 来电弹屏 */
  .common-dialog,
  .call-in-single-dialog,
  .call-in-multi-dialog {
    min-height: 100px;
    min-width: 200px;
  }

  .common-dialog,
  .call-in-single-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .call-in-multi-dialog > div {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
</style>
